import { render, staticRenderFns } from "./ElementCascader.vue?vue&type=template&id=235cd3f4&scoped=true"
import script from "./ElementCascader.vue?vue&type=script&lang=js"
export * from "./ElementCascader.vue?vue&type=script&lang=js"
import style0 from "./ElementCascader.vue?vue&type=style&index=0&id=235cd3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235cd3f4",
  null
  
)

export default component.exports